import { init as initRecastNavigation } from '@recast-navigation/core';

export const init = async () => {
  await initRecastNavigation();
};
